import { Icon } from './types';

export const YouTubeIcon: Icon = (props) => (
  <svg viewBox={'0 0 24 24'} {...props}>
    <path
      d={
        'M22.902 6.572a2.86 2.86 0 00-2.012-2.024C19.116 4.069 12 4.069 12 4.069s-7.116 0-8.89.479a2.86 2.86 0 00-2.012 2.024C.622 8.36.622 12.085.622 12.085s0 3.727.476 5.513A2.817 2.817 0 003.11 19.59c1.774.479 8.89.479 8.89.479s7.116 0 8.89-.479a2.817 2.817 0 002.012-1.992c.476-1.786.476-5.513.476-5.513s0-3.726-.476-5.513zM9.672 15.47V8.702l5.948 3.383-5.947 3.384z'
      }
    />
  </svg>
);
